import {
  OVERVIEW_PERIOD_DEFAULT,
  OVERVIEW_PERIOD_LIST,
} from '../RentalPortalOverview.constants'

import { OVERVIEW_PERIOD_LABEL_KEY } from './RentalPortalOverviewPeriodSelect.constants'

export function getOverviewPeriodOptions(t) {
  return OVERVIEW_PERIOD_LIST.map(period => ({
    label: t(OVERVIEW_PERIOD_LABEL_KEY[period]),
    value: period,
  }))
}

export function getOverviewPeriodOption({ options, period }) {
  return (
    options.find(option => option.value === period) ??
    options.find(option => option.value === OVERVIEW_PERIOD_DEFAULT)
  )
}
